import { useCallback, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./AthletePoll.module.css";

import ProgressBar from "../components/ProgressBar";
import NavPanel from "../components/NavPanel";
import Popup from "../components/Popup";

const AthletePoll = () => {
  const navigate = useNavigate();

  const [marvinReady, setMarvinReady] = useState(false);
  const [chaseReady, setChaseReady] = useState(false);
  const [willReady, setWillReady] = useState(false);

  const [marvinGrow, setMarvinGrow] = useState(false);
  const [chaseGrow, setChaseGrow] = useState(false);
  const [willGrow, setWillGrow] = useState(false);

  const [popupVisible, setPopupVisible] = useState(false);

  const sleep = ms => new Promise(r => setTimeout(r, ms));

  const onGoBackClick = useCallback(() => {
    navigate("/");
  }, [navigate]);

  const onGoNextClick = useCallback(() => {
    navigate("/marvin-trivia");
  }, [navigate]);

  const onMarvinClick = useCallback(async () => {
    document.getElementsByClassName('chase')[0].hidden = true;
    document.getElementsByClassName('will')[0].hidden = true;

    setMarvinGrow(true);
    await sleep(1000);
    navigate("/marvin-trivia");
  }, [navigate]);

  const onWillClick = useCallback(async () => {
    document.getElementsByClassName('marvin')[0].hidden = true
    document.getElementsByClassName('chase')[0].hidden = true

    setWillGrow(true);
    await sleep(1000);
    navigate("/will-trivia");
  }, [navigate]);

  const onChaseClick = useCallback(async () => {
    document.getElementsByClassName('marvin')[0].hidden = true
    document.getElementsByClassName('will')[0].hidden = true

    setChaseGrow(true);
    await sleep(1000);
    navigate("/chase-trivia");
  }, [navigate]);

  const handleVideoEnded = (event) => { 
    event.target.classList.add(styles.hideVideo)
    event.target.previousElementSibling.classList.add(styles.showPicture)
  };

  const onLogoClick = () => {
    setPopupVisible(true)
    umami?.track('Client Link - NB Logo');
  };

  return (
    <div className={styles.intro}>
      <NavPanel position='right' onClick={onGoNextClick} />
      <NavPanel onClick={onGoBackClick} />
      { (marvinGrow || willGrow || chaseGrow)  &&
        (
          <div className={styles.player}>
            <div className={styles.gradient}></div>
          </div>
        )
      }

      <div className={styles.frameParent}>
        <div className={`${styles.pageHeading} ${(marvinGrow || willGrow || chaseGrow) ? styles.hidden : ''}`}>
          <img
            className={styles.newBalanceLogo}
            alt=""
            src="./logo.png"
            onClick={onLogoClick }
          />

          <div className={styles.whoBest}>
            Who best complements your game?
          </div>
        </div>

        <div className={styles.cardPicker}>
          <div
            className={`marvin ${styles.card} ${styles.full} ${marvinGrow ? styles.grow : ""}`}
            onClick={onMarvinClick}
          >
            <img src={'marvin.jpg'} className={`${styles.athleteImg} ${styles.hidden}`} ></img>

            < video src={'marvin_clip.mp4'} 
                    className={styles.marvinVideo}
                    playsInline
                    muted
                    autoPlay
                    preload={'auto'}
                    onCanPlayThrough={() => {setMarvinReady(true)}}
                    onEnded={handleVideoEnded}>
            </video>
            <div className={styles.caption}> Marvin </div>
          </div>

          <div className={ `will ${styles.card} ${styles.half}  ${ willGrow ? styles.grow : ''}` }
            onClick={onWillClick}>
              <img src={'will.jpg'} className={`${styles.athleteImg} ${styles.hidden}`} ></img>
              < video src={'will_clip.mp4'} 
                className={styles.marvinVideo}
                playsInline
                muted
                autoPlay
                preload={'auto'}
                onCanPlayThrough={() => {setWillReady(true)}}
                onEnded={handleVideoEnded}>
              </video>

            <div className={styles.caption}>Will</div>
          </div>

          <div className={`chase ${styles.card} ${styles.half} ${chaseGrow ?  styles.grow : ''} `}
            onClick={onChaseClick}>
              <img src={'chase.jpg'} className={`${styles.athleteImg} ${styles.hidden}`} ></img>

              < video src={'chase_clip.mp4'} 
                className={styles.marvinVideo}
                playsInline
                muted
                autoPlay
                preload={'auto'}
                onCanPlayThrough={() => {setChaseReady(true)}}
                onEnded={handleVideoEnded}>
              </video>

            <div className={styles.caption}>Chase</div>
          </div>
        </div>

        <ProgressBar current='1' />
      </div>
      <Popup visible={popupVisible} onHide={() => setPopupVisible(false)}>
        Redirects to New Balance website.
      </Popup>
    </div>
  );
};

export default AthletePoll;
